import cmsApi from '@src/services/cms-api';

const Service = {
  getGameList: () => cmsApi.getArticleList({ categoryId: 7505, pageNum: 1, pageSize: 100, moreInfo: 1, api: 'https://www.xishanju.com/api.php' }),
  getRecommendList: () => cmsApi.getArticleList({ categoryId: 7518, pageNum: 1, pageSize: 3, moreInfo: 1, api: 'https://www.xishanju.com/api.php' })
};
export default Service;
